import React, { useEffect, useState } from 'react'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { CaptionSM, EyebrowMD, EyebrowSM, EyebrowXS, TitleXS } from '@/atoms/Text'
import type { NamedColor } from '@/constants/types'
import { getPeakMountainTime } from '@/views/TicketCheckoutViews/ShowtimesView/utils/utils'
import { useCountDown } from '@/views/TicketCheckoutViews/hooks/useCountDown'

export const CountdownTimer = ({
  onCountdownEnd,
  textColor,
}: {
  onCountdownEnd?: () => void
  textColor?: NamedColor
}) => {
  const [countDownDate, setCountDownDate] = useState(getPeakMountainTime())
  const { timeLeft, isExpired } = useCountDown({ utcTargetDate: countDownDate, shouldPadSeconds: true })
  const { hours, minutes, seconds } = timeLeft
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (isExpired) {
      setCountDownDate(getPeakMountainTime())
      if (onCountdownEnd) onCountdownEnd()
    }
  }, [isExpired, onCountdownEnd])

  useEffect(() => {
    setMounted(true)
    setCountDownDate(getPeakMountainTime())
  }, [])

  if (!mounted) return null

  return (
    <FlexColumn>
      <EyebrowSM className="hidden text-center lg:block" weight="semibold" color={textColor || 'white'}>
        ENDING IN
      </EyebrowSM>
      <EyebrowXS className="hidden text-center sm:block lg:hidden" weight="semibold" color={textColor || 'white'}>
        ENDING IN
      </EyebrowXS>
      <EyebrowMD className="block text-center sm:hidden" weight="semibold" color={textColor || 'white'}>
        ENDING IN
      </EyebrowMD>
      <FlexRow className="gap-3 self-center">
        <FlexRow className="items-baseline gap-0.5">
          <TitleXS weight="bold" color={textColor || 'white'}>
            {hours}
          </TitleXS>
          <CaptionSM color={textColor || 'white'}>hrs</CaptionSM>
        </FlexRow>
        <FlexRow className="items-baseline gap-0.5">
          <TitleXS weight="bold" color={textColor || 'white'}>
            {minutes}
          </TitleXS>
          <CaptionSM color={textColor || 'white'}>min</CaptionSM>
        </FlexRow>
        <FlexRow className="items-baseline gap-0.5">
          <TitleXS weight="bold" color={textColor || 'white'}>
            {seconds}
          </TitleXS>
          <CaptionSM color={textColor || 'white'}>sec</CaptionSM>
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  )
}
